export default __webpack_public_path__ + "static/media/hospital.56f87192.png";